import type * as hast from 'hast';

import { emoji, INLINE_EMOJI } from '@gitbook/doc-core';

import type { HastToGastTransformMap } from './types';
import { getCustomAttributes } from './utils';

/**
 * Custom inlines to transform.
 */
export const transformInlineCustoms: HastToGastTransformMap<hast.Element> = {
    [INLINE_EMOJI]: async (node) => {
        const { code } = getCustomAttributes(node);
        if (typeof code !== 'string') {
            return [];
        }
        return [emoji.createEmoji(code)];
    },
};
